import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserInfoSection from "./userinfo";
import { useLoginContext } from "../Contexts/LoginContext";

function UserIcon({role}) {
  const navigate = useNavigate();
  const{loggedIn}=useLoginContext();



  const toggleUserMenu = () => {
    navigate("/login");
  };

  return (
    <div>
      {loggedIn ? (
        <UserInfoSection  />
      ) : (
        <img
          src="/icons/user.png"
          className="icon h-10 cursor-pointer"
          onClick={toggleUserMenu}
          alt="User Icon"
        />
      )}
    </div>
  );
}

export default UserIcon;
